/**
API/External Data Configuration.

This file contains any necessary environment variables used for the storefront application
that ARE ONLY related to API/external data sources.

Please help to ensure that this separation is observed as, in the future, the
API suite may be exported for use in other applications.

* */

interface IEnvironmentConfigAPI {
    VITE_APP_ENV: string;
    VITE_BUILD_NUMBER: string;
    VITE_API_BASE_URL_AUTHORIZATION: string;
    VITE_CHASE_SCRIPT_HOST: string;
    VITE_GOOGLE_TAG_MANAGER_ID: string;
    VITE_INSURANCE_APP_API_BASE_URL: string;
    VITE_API_BASE_URL_LOAN_MGMT: string;
    VITE_API_BASE_URL_PRODUCT_MANAGEMENT: string;
    VITE_RECAPTCHA_SITE_KEY: string;
    VITE_API_BASE_URL_RESOURCE: string;
    VITE_SAFETY_NET_LOADING_TIMER: string;
    VITE_API_BASE_URL_TENANT: string;
    VITE_API_BASE_URL_TOKEN: string;
    VITE_APIM_TOKEN: string;
    VITE_SA_DLI_PASSWORD: string;
    VITE_API_BASE_URL_USER: string;
    VITE_API_BASE_URL_USPS: string;
    VITE_ONETRUST_DATA_DOMAIN_SCRIPT: string;
    VITE_API_BASE_URL_DLI_ADAPTER: string;
    VITE_APIM_SUBSCRIPTION_KEY_FICUS: string;
    VITE_APIM_SUBSCRIPTION_KEY_DLI_ADAPTER: string;
    VITE_API_BASE_URL_INSURANCE_APPLICATION: string;
    VITE_APIM_SUBSCRIPTION_KEY_INSURANCE_APPLICATION: string;
    VITE_INIT_URL: string;
    VITE_PROCESS_URL: string;
    VITE_UPDATE_PROFILE_URL: string;
    VITE_FETCH_PROFILE_URL: string;
    VITE_CHASE_FORM_NAME: string;
    VITE_CHASE_TENANT_ID: string;
    VITE_CHASE_HIDE_ACCNT_NUM: string;
    VITE_CHASE_RETRY_LIMIT: string;
    VITE_CHASE_TOKENIZE: string;
    VITE_CHASE_TOTAL_AMOUNT: string;
    VITE_CHASE_TXN_TYPE: string;
    VITE_CHASE_ORDER_ID: string;
    VITE_MIT_MSG_TYPE: string;
    VITE_MIT_STORED_CREDENTIAL_IND: string;
    VITE_SUBSCRIPTION_KEY: string;
}
function setConfig(): IEnvironmentConfigAPI {
    if (import.meta.env.PROD) {
        return window.CONFIG_PaymentProtectionEnrollmentUI as unknown as IEnvironmentConfigAPI;
    }

    return {
        VITE_APP_ENV: import.meta.env.VITE_APP_ENV as string,
        VITE_API_BASE_URL_AUTHORIZATION: import.meta.env.VITE_API_BASE_URL_AUTHORIZATION as string,
        VITE_BUILD_NUMBER: import.meta.env.VITE_BUILD_NUMBER as string,
        VITE_CHASE_SCRIPT_HOST: import.meta.env.VITE_CHASE_SCRIPT_HOST as string,
        VITE_GOOGLE_TAG_MANAGER_ID: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID as string,
        VITE_INSURANCE_APP_API_BASE_URL: import.meta.env.VITE_INSURANCE_APP_API_BASE_URL as string,
        VITE_API_BASE_URL_LOAN_MGMT: import.meta.env.VITE_API_BASE_URL_LOAN_MGMT as string,
        VITE_API_BASE_URL_PRODUCT_MANAGEMENT: import.meta.env.VITE_API_BASE_URL_PRODUCT_MANAGEMENT as string,
        VITE_RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY as string,
        VITE_API_BASE_URL_RESOURCE: import.meta.env.VITE_API_BASE_URL_RESOURCE as string,
        VITE_SAFETY_NET_LOADING_TIMER: import.meta.env.VITE_SAFETY_NET_LOADING_TIMER as string,
        VITE_API_BASE_URL_TENANT: import.meta.env.VITE_API_BASE_URL_TENANT as string,
        VITE_API_BASE_URL_TOKEN: import.meta.env.VITE_API_BASE_URL_TOKEN as string,
        VITE_APIM_TOKEN: import.meta.env.VITE_APIM_TOKEN as string,
        VITE_SA_DLI_PASSWORD: import.meta.env.VITE_SA_DLI_PASSWORD as string,
        VITE_API_BASE_URL_USER: import.meta.env.VITE_API_BASE_URL_USER as string,
        VITE_API_BASE_URL_USPS: import.meta.env.VITE_API_BASE_URL_USPS as string,
        VITE_ONETRUST_DATA_DOMAIN_SCRIPT: import.meta.env.VITE_ONETRUST_DATA_DOMAIN_SCRIPT as string,
        VITE_API_BASE_URL_DLI_ADAPTER: import.meta.env.VITE_API_BASE_URL_DLI_ADAPTER as string,
        VITE_APIM_SUBSCRIPTION_KEY_FICUS: import.meta.env.VITE_APIM_SUBSCRIPTION_KEY_FICUS as string,
        VITE_APIM_SUBSCRIPTION_KEY_DLI_ADAPTER: import.meta.env.VITE_APIM_SUBSCRIPTION_KEY_DLI_ADAPTER as string,
        VITE_API_BASE_URL_INSURANCE_APPLICATION: import.meta.env.VITE_API_BASE_URL_INSURANCE_APPLICATION as string,
        VITE_APIM_SUBSCRIPTION_KEY_INSURANCE_APPLICATION: import.meta.env
            .VITE_APIM_SUBSCRIPTION_KEY_INSURANCE_APPLICATION as string,
        VITE_INIT_URL: import.meta.env.VITE_INIT_URL as string,
        VITE_PROCESS_URL: import.meta.env.VITE_PROCESS_URL as string,
        VITE_UPDATE_PROFILE_URL: import.meta.env.VITE_UPDATE_PROFILE_URL as string,
        VITE_FETCH_PROFILE_URL: import.meta.env.VITE_FETCH_PROFILE_URL as string,
        VITE_CHASE_FORM_NAME: import.meta.env.VITE_CHASE_FORM_NAME as string,
        VITE_CHASE_TENANT_ID: import.meta.env.VITE_CHASE_TENANT_ID as string,
        VITE_CHASE_HIDE_ACCNT_NUM: import.meta.env.VITE_CHASE_HIDE_ACCNT_NUM as string,
        VITE_CHASE_RETRY_LIMIT: import.meta.env.VITE_CHASE_RETRY_LIMIT as string,
        VITE_CHASE_TOKENIZE: import.meta.env.VITE_CHASE_TOKENIZE as string,
        VITE_CHASE_TOTAL_AMOUNT: import.meta.env.VITE_CHASE_TOTAL_AMOUNT as string,
        VITE_CHASE_TXN_TYPE: import.meta.env.VITE_CHASE_TXN_TYPE as string,
        VITE_CHASE_ORDER_ID: import.meta.env.VITE_CHASE_ORDER_ID as string,
        VITE_MIT_MSG_TYPE: import.meta.env.VITE_MIT_MSG_TYPE as string,
        VITE_MIT_STORED_CREDENTIAL_IND: import.meta.env.VITE_MIT_STORED_CREDENTIAL_IND as string,
        VITE_SUBSCRIPTION_KEY: import.meta.env.VITE_SUBSCRIPTION_KEY as string
    };
}

export default setConfig();
